var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AccountsRestore"}},[_c('div',[_c('Restore',{on:{"on-restore":function($event){return _vm.$emit('on-restore')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }